/** @jsx jsx */
import { jsx } from '@emotion/core';
import { badgeContainerCSS, containerCSS } from './styles';
export var NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
export var BadgeContainer = function BadgeContainer(props) {
  var Badge = props.badge,
      children = props.children;
  return jsx("div", {
    css: containerCSS
  }, children, jsx("div", {
    css: badgeContainerCSS,
    id: NOTIFICATIONS_BADGE_ID,
    "aria-hidden": true
  }, jsx(Badge, null)));
};